import { render, staticRenderFns } from "./ExaminVideoUpload.vue?vue&type=template&id=2528b93e&scoped=true"
import script from "./ExaminVideoUpload.vue?vue&type=script&lang=js"
export * from "./ExaminVideoUpload.vue?vue&type=script&lang=js"
import style0 from "./ExaminVideoUpload.vue?vue&type=style&index=0&id=2528b93e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2528b93e",
  null
  
)

export default component.exports